import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './component/home/home.component';
import { LoginComponent } from './component/login/login.component';
import { PortafolioComponent } from './component/portafolio/portafolio.component';
import { CarnetComponent } from './component/carnet/carnet.component';
import { MaincontainerComponent } from './component/maincontainer/maincontainer.component';
import { ForgetPasswordComponent } from './component/forget-password/forget-password.component';
import { AuthGuard } from './core/security/auth.guard';
import { CotizadorComponent } from './component/cotizador/cotizador.component';
import { MisCotizacionesComponent } from './component/misCotizaciones/mis-cotizaciones.component';
import { MiCotizacionComponent } from './component/miCotizacion/mi-cotizacion.component';
import { PoblacionComponent } from './component/poblacion/poblacion.component';
import { ConsultaPoblacionComponent } from './component/consultaPoblacion/consultaPoblacion.component';
import { LoginGuard } from './core/security/login.guard';
import { AfiliacionesComponent } from './component/afiliaciones/afiliaciones.component';
import { ComisionesComponent } from './component/comisiones/comisiones.component';
import { IframeGenericComponent } from './component/common/iframe-generic/iframe-generic.component';
import {OportunidadesComercialesInternosComponent} from './component/oportunidades-comerciales-internos/oportunidades-comerciales-internos.component';
import { MisOportunidadesComercialesAsesorExternoComponent } from './component/mis-oportunidades-comerciales-acesor-externo/mis-oportunidades-comerciales-acesor-externo.component';
import { OportunidadesRedirectComponent } from './component/oportunidades-redirect/oportunidades-redirect.component';
// doc 8
import { RadicacionTrasladosComponent } from './component/radicacion-traslados/radicacion-traslados.component';
import { FirmasComponent } from './component/firmas/firmas.component';
// doc 9
import { MisReferidosComponent } from './component/mis-referidos/mis-referidos.component';
import { SeguimientoReferidosComponent } from './component/seguimiento-referidos/seguimiento-referidos.component';
import { AutorizacionesComponent } from './component/autorizaciones/autorizaciones.component';
import { DescargasTokenComponent } from './component/descarga-reporte/descargas-token.component';
import { CertificadoRetencionComponent } from './component/certificado-retencion/certificado-retencion.component';
import { CotizadorSeguimientoComponent } from './component/cotizador-seguimiento/cotizador-seguimiento.component';
import { NotificacionesComponent } from './component/notificaciones/notificaciones.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
  { path: 'forgetPassword', component: ForgetPasswordComponent },
  { path: 'descargas/:token', component: DescargasTokenComponent },
  { path: 'firmas', component: FirmasComponent },
  {
    path: 'main',
    component: MaincontainerComponent,
    canActivate: [AuthGuard],
    children: [
      //{ path: 'home', component: HomeComponent },
      { path: 'portafolio', component: PortafolioComponent },
      { path: 'carnet', component: CarnetComponent },
      { path: 'poblacion', component: PoblacionComponent },
      { path: 'consultapoblacion', component: ConsultaPoblacionComponent },
      { path: 'forgetPassword', component: ForgetPasswordComponent },
      { path: 'cotizador', component: CotizadorComponent },
      { path: 'miscotizaciones', component: MisCotizacionesComponent },
      { path: 'miscotizaciones/:numero_cotizacion', component: MiCotizacionComponent },
      { path: 'afiliaciones', component: AfiliacionesComponent },
      { path: 'gestion-referidos', component: MisReferidosComponent },
      {
        path: 'seguimiento-referidos',
        component: SeguimientoReferidosComponent,
      },
      { path: 'comisiones', component: ComisionesComponent },
      { path: 'radicacion-traslados', component: RadicacionTrasladosComponent },
      {
        path: 'miscotizaciones/:numero_cotizacion',
        component: MiCotizacionComponent,
      },
      {
        path: 'primera-cuota',
        component: IframeGenericComponent,
        data: { title: 'LINK DE PAGO PRIMERA CUOTA' },
      },
      {
        path: 'gestor-links',
        component: IframeGenericComponent,
        data: { title: 'GESTOR DE LINKS' },
      },
      // Ruta pública
      {
        path: 'oportunidades-comerciales',
        component: OportunidadesRedirectComponent,
      },

      // Rutas internas reales
      {
        path: 'oportunidades-comerciales-internos',
        component: OportunidadesComercialesInternosComponent,
      },
      {
        path: 'oportunidades-comerciales-externos',
        component: MisOportunidadesComercialesAsesorExternoComponent,
      },
      { path: 'autorizaciones', component: AutorizacionesComponent },
      { path: 'mis-referidos', component: MisReferidosComponent },
      { path: 'certificados-retenciones', component: CertificadoRetencionComponent },
      { path: 'cotizador-seguimiento', component: CotizadorSeguimientoComponent },
      { path: 'notificaciones-cotizacion', component: NotificacionesComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
